import React from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import HeaderContainer from 'containers/header/header-container';
import { parseQueryParams } from 'utils/query-param-util';
import { toBoolean } from 'utils/string-util';

const WorksheetMakerContainer = ({ children }) => {
  const location = useLocation();
  const isLite = toBoolean(parseQueryParams(location.search)?.lite);

  return (
    <Box style={{ height: !isLite ? 'calc(100% - 60px)' : '100%' }}>
      {!isLite && <HeaderContainer />}
      {children}
    </Box>
  );
};

export default WorksheetMakerContainer;
